import { VideoLengthRange } from '@ads/front-core/api'

const DURATION_OPTIONS: Record<VideoLengthRange, string> = {
  SHORT: '4-6',
  MEDIUM: '7-15',
  LONG: '16-30',
}

const BANNER_VARIANTS = [
  '300x250',
  '750x200',
  '750x300',
  '970x300',
  '940x600',
  '300x600',
]

export const getOutstreamRanges = (): VideoLengthRange[] =>
  Object.keys(DURATION_OPTIONS) as VideoLengthRange[]

export const getOutstreamDuration = (lengthRange: VideoLengthRange) =>
  DURATION_OPTIONS[lengthRange]

export const getOutstreamBannerVariants = () => BANNER_VARIANTS
